export default defineAppConfig({
  baseTitle: "Cashtec",
  appName: "cashtec"
});
